import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useWorkspace } from "@/context/WorkspaceContext";
import { reactivateSubscription } from "@/services/cancellationService";
import CancellationDialog from "@/components/cancellation/CancellationDialog";

export const CancellationGate: React.FC = () => {
  const { fetchProfile } = useAuth();
  const { endedWorkspace, refreshWorkspaces } = useWorkspace();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleReactivate = async (): Promise<void> => {
    if (submitting) return;

    setSubmitting(true);
    setError(null);
    try {
      await reactivateSubscription();
    } catch (requestError) {
      setError(
        requestError instanceof Error
          ? requestError.message
          : "We couldn't reactivate your subscription. Try again.",
      );
      setSubmitting(false);
      return;
    }

    try {
      await Promise.all([refreshWorkspaces(), fetchProfile()]);
    } catch {
      setError(
        "Your subscription was reactivated, but the workspace could not be refreshed. Reload this page.",
      );
      setSubmitting(false);
    }
  };

  return (
    <div className="vb-root min-h-screen bg-vb-bg-subtle">
      <CancellationDialog
        lockReason={endedWorkspace?.access_state?.lock_reason ?? null}
        error={error}
        submitting={submitting}
        onReactivate={() => void handleReactivate()}
      />
    </div>
  );
};

export default CancellationGate;